export const MAKSUAIKOJEN_VAKIOVAIHTOEHDOT: readonly number[] = [7, 14, 21, 30, 45, 60]

/**
 * Valittavat maksuajat päivinä pienimmästä suurimpaan. Nykyinen maksuaika on aina mukana, vaikka se ei olisi
 * vakiovaihtoehto tai alittaisi vähimmäismaksuajan, jotta valinta näyttää tallennetun arvon.
 */
export function annaMaksuaikaVaihtoehdot(nykyinen: number | null | undefined, vahimmaismaksuaika = 1): number[] {
  const vaihtoehdot = MAKSUAIKOJEN_VAKIOVAIHTOEHDOT.filter(paivia => paivia >= vahimmaismaksuaika)
  if (nykyinen && !vaihtoehdot.includes(nykyinen)) {
    vaihtoehdot.push(nykyinen)
  }
  return vaihtoehdot.sort((a, b) => a - b)
}
